import request from '@/utils/http'

// 后台科目管理：
// 新增科目:
function subjectAdd (params: any) {
  return request({
    url: `subject/add`,
    method: 'post',
    data: params
  })
}

// 获取科目树:
function subjectTreeOfGet () {
  return request({
    url: `subject/tree`,
    method: 'get'
  })
}

// 保存科目单位:
function subjectUnitSave (params: any) {
  return request({
    url: `subject/unitSave`,
    method: 'get',
    params
  })
}

// 修改科目:
function subjectUpdate (params: any) {
  return request({
    url: `subject/update`,
    method: 'post',
    data: params
  })
}

// 后台流水管理：
// 记账：
function journalBookkeeping (params: any) {
  return request({
    url: `journal/bookkeeping`,
    method: 'post',
    data: params
  })
}

// 删账：
function journalDelete (params: any) {
  return request({
    url: `journal/delete`,
    method: 'delete',
    params
  })
}

// 查账：
function journalQuery (params: any) {
  return request({
    url: `journal/query`,
    method: 'get',
    params
  })
}

// 改账：
function journalUpdate (params: any) {
  return request({
    url: `journal/update`,
    method: 'post',
    data: params
  })
}

// 后台库存管理：
// 保存库存记录：
function inventorySave (params: any) {
  return request({
    url: `inventory/save`,
    method: 'post',
    data: params
  })
}

// 查看库存记录：
function inventoryQuery (params: any) {
  return request({
    url: `inventory/query`,
    method: 'get',
    params
  })
}

// 删除库存记录：
function inventoryDelInventory (params: any) {
  return request({
    url: `inventory/delInventory`,
    method: 'delete',
    params
  })
}

// 食堂基本信息管理：
// 获取食堂基本信息：
function portalGetCanteenInfo (params: any) {
  return request({
    url: `portal/getCanteenInfo`,
    method: 'get',
    params
  })
}

// 保存食堂基本信息：
function portalSaveCanteenInfo (params: any) {
  return request({
    url: `portal/saveCanteenInfo`,
    method: 'post',
    data: params
  })
}

// 查询科目单位表:
function canteenCommonQuerySubjectUnit (params: any) {
  return request({
    url: `common/querySubjectUnit`,
    method: 'get'
  })
}

// 食堂资金管理：
// 保存情况总览：
function capitalInfoSave (params: any) {
  return request({
    url: `capital/info/save`,
    method: 'post',
    data: params
  })
}

// 查看情况总览：
function capitalInfo (params: any) {
  return request({
    url: `capital/info`,
    method: 'get',
    params
  })
}

// 提交申请：
function capitalAppInsert (params: any) {
  return request({
    url: `capital/app/insert`,
    method: 'post',
    data: params
  })
}

// 查询申请记录：
function capitalAppQuery (params: any) {
  return request({
    url: `capital/app/query`,
    method: 'put',
    data: params
  })
}

// 下载资金转入记录导入模版:
function capitalTransferDownloadTemplate () {
  return request({
    url: `capital/transfer/downloadTemplate`,
    method: 'get',
    responseType: 'arraybuffer' // 或者responseType: 'blob'
  })
}

// 导入资金转入记录：
function capitalTransferImport (params: FormData) {
  return request({
    url: `capital/transfer/import`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  })
}

// 新增资金转入记录：
function capitalTransferInsert (params: any) {
  return request({
    url: `capital/transfer/insert?role=${params.role}`,
    method: 'post',
    data: params
  })
}

// 查询资金转入记录：
function capitalTransferQuery (params: any) {
  return request({
    url: `capital/transfer/query`,
    method: 'put',
    data: params
  })
}

// 删除资金转入记录：
function capitalTransferDel (params: any) {
  return request({
    url: `capital/transfer/del`,
    method: 'delete',
    params
  })
}

// 导出申请记录:
function capitalAppExport (params: any) {
  return request({
    url: `capital/app/export`,
    method: 'put',
    data: params,
    responseType: 'blob'
  })
}

// 学校端查询资金转入记录：
function capitalInfoTransferInfo (params: any) {
  return request({
    url: `capital/info/transferInfo`,
    method: 'get',
    params
  })
}

// 处理申请（审批或驳回或取消）：
function capitalAppApprove (params: any) {
  return request({
    url: `capital/app/approve`,
    method: 'post',
    data: params
  })
}

// 修改申请内容：
function capitalAppUpdate (params: any) {
  return request({
    url: `capital/app/update`,
    method: 'post',
    data: params
  })
}

// 创建或修改公告：
function newAnnouncementSaveOrUpdate (params: any) {
  return request({
    url: `newAnnouncement/saveOrUpdate`,
    method: 'post',
    data: params
  })
}

// 分页查询已经创建的公告：
function newAnnouncementListPage (params: any) {
  return request({
    url: `newAnnouncement/listPage`,
    method: 'post',
    data: params
  })
}

// 查询详细信息：
function newAnnouncementGetById (params: { id: number, loginUserType: number }) {
  return request({
    url: `newAnnouncement/getById/${params.id}?loginUserType=${params.loginUserType}`,
    method: 'get'
  })
}

// 通过ID 删除记录：
function newAnnouncementRemoveById (id: any) {
  return request({
    url: `newAnnouncement/removeById/${id}`,
    method: 'delete'
  })
}

// 分页查询自己可以查看的公告：
function newAnnouncementUserAnnouncementPage (params: any) {
  return request({
    url: `newAnnouncement/userAnnouncementPage`,
    method: 'post',
    data: params
  })
}

// 查询已经看过公告的用户：
function newAnnouncementSelectReadUser (params: any) {
  return request({
    url: `newAnnouncement/selectReadUser`,
    method: 'get',
    params
  })
}

// 保存陪餐记录：
function dailyEatTogetherSave (params: any) {
  return request({
    url: `daily/eatTogether/save`,
    method: 'post',
    data: params
  })
}

// 查看陪餐记录：
function dailyEatTogetherQuery (params: any) {
  return request({
    url: `daily/eatTogether/query`,
    method: 'get',
    params
  })
}

// 删除陪餐记录：
function dailyEatTogetherDel (params: any) {
  return request({
    url: `daily/eatTogether/del`,
    method: 'delete',
    params
  })
}

// 保存培训记录：
function dailyTrainingSave (params: any) {
  return request({
    url: `daily/training/save`,
    method: 'post',
    data: params
  })
}

// 查看培训记录：
function dailyTrainingQuery (params: any) {
  return request({
    url: `daily/training/query`,
    method: 'get',
    params
  })
}

// 删除培训记录：
function dailyTrainingDel (params: any) {
  return request({
    url: `daily/training/del`,
    method: 'delete',
    params
  })
}

// 保存留样记录：
function dailyRcordDishesSave (params: any) {
  return request({
    url: `daily/recordDishes/save`,
    method: 'post',
    data: params
  })
}

// 查看留样记录：
function dailyRecordDishesQuery (params: any) {
  return request({
    url: `daily/recordDishes/query`,
    method: 'get',
    params
  })
}

// 删除留样记录：
function dailyRecordDishesDel (params: any) {
  return request({
    url: `daily/recordDishes/del`,
    method: 'delete',
    params
  })
}

// 保存消杀记录：
function dailyDisinfectSave (params: any) {
  return request({
    url: `daily/disinfect/save`,
    method: 'post',
    data: params
  })
}

// 查看消杀记录：
function dailyDisinfectQuery (params: any) {
  return request({
    url: `daily/disinfect/query`,
    method: 'get',
    params
  })
}

// 删除消杀记录：
function dailyDisinfectDel (params: any) {
  return request({
    url: `daily/disinfect/del`,
    method: 'delete',
    params
  })
}

// 保存人员管理：
function dailyStaffAdd (params: any) {
  return request({
    url: `daily/staff/add`,
    method: 'post',
    data: params
  })
}

// 查看人员管理：
function dailyStaffQuery (params: any) {
  return request({
    url: `daily/staff/query`,
    method: 'get',
    params
  })
}

// 删除人员管理：
function dailyStaffDel (params: any) {
  return request({
    url: `daily/staff/del`,
    method: 'delete',
    params
  })
}

// 生成月凭证：
function journalGenerateProof (params: any) {
  return request({
    url: `journal/generate/proof`,
    method: 'put',
    data: params
  })
}

// 查询凭证：
function financeProofQuery (params: any) {
  return request({
    url: `financeProof/query`,
    method: 'put',
    data: params
  })
}

// 凭证审核：
function financeProofAduit (params: any) {
  return request({
    url: `financeProof/aduit`,
    method: 'post',
    data: params
  })
}

// 查询收支明细表：
function reportFormIncomeAndOutputDetailQuery (params: any) {
  return request({
    url: `reportForm/incomeAndOutputDetail/query`,
    method: 'get',
    params
  })
}

// 查询资产负债表：
function reportFormAssetsAndLiabilitiesQuery (params: any) {
  return request({
    url: `reportForm/assetsAndLiabilities/query`,
    method: 'get',
    params
  })
}

// 查询科目余额表：
function reportFormSubjectBalanceQuery (params: any) {
  return request({
    url: `reportForm/subjectBalance/query`,
    method: 'get',
    params
  })
}

// 查询初期余额：
function portalQuerySubjectInitBalance (params: any) {
  return request({
    url: `portal/querySubjectInitBalance`,
    method: 'get',
    params
  })
}

// 插入初期余额:
function portalInsertSubjectInitBalance (params: any) {
  return request({
    url: `portal/insertSubjectInitBalance`,
    method: 'post',
    data: params
  })
}

// 生成科目余额表：
function journalGenerateSubjectBalanceForm (params: any) {
  return request({
    url: `journal/generate/subjectBalanceForm`,
    method: 'put',
    data: params
  })
}

// 清空凭证：
function financeProofTruncate (params: any) {
  return request({
    url: `financeProof/truncate`,
    method: 'post',
    data: params
  })
}

// 清空科目余额表：
function reportFormSubjectBalanceTruncate (params: any) {
  return request({
    url: `reportForm/subjectBalance/truncate`,
    method: 'put',
    data: params
  })
}

// 资金转入记录审批-确认-取消：
function capitalTransferApprove (params: any) {
  return request({
    url: `capital/transfer/approve`,
    method: 'post',
    data: params
  })
}

// 获取收据：
function capitalReceiptGet (params: any) {
  return request({
    url: `capital/receipt/get`,
    method: 'get',
    params
  })
}

// auditLog：
function getLogAudit (params: any) {
  return request({
    url: `log/audit`,
    method: 'get',
    params
  })
}

// addPriceUnitSection：
function adminAddPriceUnit (params: any) {
  return request({
    url: `admin/add/priceUnit`,
    method: 'post',
    data: params
  })
}

// listPriceUnitSection：
function adminListPriceUnit (params: any) {
  return request({
    url: `admin/list/priceUnit`,
    method: 'get'
  })
}

// updatePriceSection：
function adminUpdateByIdpriceUnit (params: any) {
  return request({
    url: `admin/update/${params.id}/priceUnit?max=${params.max}&min=${params.min}`,
    method: 'post'
  })
}

// addConfig：
function warningConfigAdd (params: any) {
  return request({
    url: `warning/config/add`,
    method: 'post',
    data: params
  })
}

// queryConfig：暂时用不到
function warningConfigQuery (params: any) {
  return request({
    url: `warning/config/query`,
    method: 'get',
    params
  })
}

// queryConfigCalendar：
function warningConfigQueryCalendar (params: any) {
  return request({
    url: `warning/config/query/calendar`,
    method: 'get',
    params
  })
}

// active：
function warningConfigActive (params: any) {
  return request({
    url: `warning/config/active`,
    method: 'get',
    params
  })
}

// del：
function warningConfigDelById (params: any) {
  return request({
    url: `warning/config/del/${params.id}`,
    method: 'delete'
  })
}

// warnInfoQuery：
function warningInfoQuery (params: any) {
  return request({
    url: `warning/info/query`,
    method: 'put',
    data: params
  })
}

// warnInfoQueryHandler：
function warnInfoQueryHandler (params: any) {
  return request({
    url: `warning/info/query/handler`,
    method: 'put',
    data: params
  })
}

// 查流水聚合表：
function journalAggQuery (params: any) {
  return request({
    url: `journal/agg/query`,
    method: 'get',
    params
  })
}

// handlerWarning：
function warningInfoAudit (params: any) {
  return request({
    url: `warning/info/audit`,
    method: 'post',
    data: params
  })
}

// 查询当前节点及子节点下未处理完成的预警：
function warningInfoQueryNotComplete (params: any) {
  return request({
    url: `warning/info/query/notComplete`,
    method: 'put',
    data: params
  })
}

// 更新初期余额：
function portalUpdateSubjectInitBalance (params: any) {
  return request({
    url: `portal/updateSubjectInitBalance`,
    method: 'post',
    data: params
  })
}

// 结转：
function financeProofInOutTrans (params: any) {
  return request({
    url: `financeProof/inOut/trans`,
    method: 'post',
    data: params
  })
}

// 清空结转：
function financeProofInOutTransTruncate (params: any) {
  return request({
    url: `financeProof/inOut/trans/truncate`,
    method: 'post',
    data: params
  })
}

// 生成总账：
function financeProofLedger (params: any) {
  return request({
    url: `financeProof/ledger`,
    method: 'post',
    params
  })
}

// 清空总账：
function financeProofLedgerTruncate (params: any) {
  return request({
    url: `financeProof/ledger/truncate`,
    method: 'post',
    params
  })
}

// 生成明细账：
function financeProofLedgerDetail (params: any) {
  return request({
    url: `financeProof/ledger/detail`,
    method: 'post',
    params
  })
}

// 清空明细账：
function financeProofLedgerDetailTruncate (params: any) {
  return request({
    url: `financeProof/ledger/detail/truncate`,
    method: 'post',
    params
  })
}

// 修改资金转入记录、学校端修改：
function capitalTransferUpdate (params: any) {
  return request({
    url: `capital/transfer/update?role=${params.role}`,
    method: 'post',
    data: params
  })
}

function capitalTransferExport (params: any) {
  return request({
    url: `capital/transfer/export`,
    method: 'put',
    data: params,
    responseType: 'blob'
  })
}

function capitalAgg (params: any) {
  return request({
    url: `capital/capital/agg`,
    method: 'put',
    data: params
  })
}

// 所有学校基本信息：
function schoolInfoList (params: any) {
  return request({
    url: `capital/info/list`,
    method: 'get',
    params
  })
}

// 查询明细账：
function reportFormLedgerDetail (params: any) {
  return request({
    url: `reportForm/ledger/detail`,
    method: 'get',
    params
  })
}

// 查询总账：
function reportFormLedger (params: any) {
  return request({
    url: `reportForm/ledger`,
    method: 'get',
    params
  })
}

// 库存余量查询：
function inventoryStock (params: any) {
  return request({
    url: `inventory/stock`,
    method: 'get',
    params
  })
}

// 科目分析数据：
function reportFormSubjectAnalyze (params: any) {
  return request({
    url: `reportForm/subject/analyze`,
    method: 'get',
    params
  })
}

// 分页查询供应商信息：
function supplierList (params: any) {
  return request({
    url: `supplier/list`,
    method: 'get',
    params
  })
}

// 录入供应商信息：
function supplierAdd (params: any) {
  return request({
    url: `supplier/add`,
    method: 'post',
    data: params
  })
}

// 批量修改供应商状态：
function supplierStatus (params: any) {
  return request({
    url: `supplier/status/${params.status}`,
    method: 'post',
    data: params.supplierIds
  })
}

// 配置收费标准：
export const chargeModify = (params: any) => {
  return request({
    url: `recharge/admin/charge/modify/10000`,
    method: 'post',
    data: params
  })
}

// 查询收费标准：
export const chargeConfig = () => {
  return request({
    url: `recharge/chargeConfig/10000`,
    method: 'get'
  })
}

// 查询充值记录：
export const rechargePage = (params: any) => {
  return request({
    url: `recharge/admin/page`,
    method: 'get',
    params
  })
}

export default {
  subjectAdd,
  subjectTreeOfGet,
  subjectUnitSave,
  subjectUpdate,
  journalBookkeeping,
  journalDelete,
  journalQuery,
  journalUpdate,
  inventorySave,
  inventoryQuery,
  inventoryDelInventory,
  portalGetCanteenInfo,
  portalSaveCanteenInfo,
  canteenCommonQuerySubjectUnit,
  capitalInfoSave,
  capitalInfo,
  capitalAppInsert,
  capitalAppQuery,
  capitalTransferDownloadTemplate,
  capitalTransferImport,
  capitalTransferInsert,
  capitalTransferQuery,
  capitalTransferDel,
  capitalAppExport,
  capitalInfoTransferInfo,
  capitalAppApprove,
  capitalAppUpdate,
  newAnnouncementSaveOrUpdate,
  newAnnouncementListPage,
  newAnnouncementGetById,
  newAnnouncementRemoveById,
  newAnnouncementUserAnnouncementPage,
  newAnnouncementSelectReadUser,
  dailyEatTogetherSave,
  dailyEatTogetherQuery,
  dailyEatTogetherDel,
  dailyTrainingSave,
  dailyTrainingQuery,
  dailyTrainingDel,
  dailyRcordDishesSave,
  dailyRecordDishesQuery,
  dailyRecordDishesDel,
  dailyDisinfectSave,
  dailyDisinfectQuery,
  dailyDisinfectDel,
  dailyStaffAdd,
  dailyStaffQuery,
  dailyStaffDel,
  journalGenerateProof,
  financeProofQuery,
  financeProofAduit,
  reportFormIncomeAndOutputDetailQuery,
  reportFormAssetsAndLiabilitiesQuery,
  reportFormSubjectBalanceQuery,
  portalQuerySubjectInitBalance,
  portalInsertSubjectInitBalance,
  journalGenerateSubjectBalanceForm,
  financeProofTruncate,
  reportFormSubjectBalanceTruncate,
  capitalTransferApprove,
  capitalReceiptGet,
  getLogAudit,
  adminAddPriceUnit,
  adminListPriceUnit,
  adminUpdateByIdpriceUnit,
  warningConfigAdd,
  warningConfigQuery,
  warningConfigQueryCalendar,
  warningConfigActive,
  warningConfigDelById,
  warningInfoQuery,
  warnInfoQueryHandler,
  journalAggQuery,
  warningInfoAudit,
  warningInfoQueryNotComplete,
  portalUpdateSubjectInitBalance,
  financeProofInOutTrans,
  financeProofInOutTransTruncate,
  financeProofLedger,
  financeProofLedgerTruncate,
  financeProofLedgerDetail,
  financeProofLedgerDetailTruncate,
  capitalTransferUpdate,
  capitalTransferExport,
  capitalAgg,
  schoolInfoList,
  reportFormLedgerDetail,
  reportFormLedger,
  inventoryStock,
  reportFormSubjectAnalyze,
  supplierList,
  supplierAdd,
  supplierStatus
}
